import { Skeleton } from '../../components/skeleton';

const numberFormatter = new Intl.NumberFormat();
export function StatisticBlock({ title, value }: { title: string; value?: number }) {
  return (
    <div className="flex min-w-min flex-col justify-between gap-2 rounded-lg border bg-gray-50 p-4">
      <div className="flex items-center gap-1.5">
        <p className="text-xs font-medium tracking-wider text-gray-500 uppercase">{title}</p>
      </div>
      <div className="flex h-9 items-center text-3xl font-semibold tracking-tight text-gray-900 tabular-nums">
        {value !== undefined ? (
          <span className="animate-in fade-in">{numberFormatter.format(value)}</span>
        ) : (
          <Skeleton className="h-7 w-16 bg-gray-200/70" />
        )}
      </div>
    </div>
  );
}
